export const certificationData = [
  {
    img: "responsive",
    alt: "Responsive Web Design",
  },
  {
    img: "javascript",
    alt: "JavaScript Algorithms and Data Structures",
  },
  {
    img: "metaFE",
    alt: "Meta Front-End Developer Specialization",
  },
  {
    img: "metaIntro",
    alt: "Introduction to Front-end Development",
  },
  {
    img: "metaJavascript",
    alt: "Programming with Javascript",
  },
  {
    img: "metaVersionControl",
    alt: "Version Control",
  },
  {
    img: "metaHtmlCss",
    alt: "HTML and CSS in depth",
  },
  {
    img: "metaReact",
    alt: "React Basics",
  },
  {
    img: "metaAdvancedReact",
    alt: "AdvancedReact",
  },
  {
    img: "metaUXUI",
    alt: "Principles of UX/UI Design",
  },
  {
    img: "metaCapstone",
    alt: "Front-End Developer Capstone",
  },
  {
    img: "metaCoding",
    alt: "Coding Interview Preparation",
  },
  {
    img: "fundamental",
    alt: "Web Development Fundamentals",
  },
  {
    img: "html",
    alt: "HTML",
  },
];

export const skillData = [
  {
    icon: "AiFillHtml5",
    title: "HTML",
  },
];

export const projectData = [
    {
    thumbnail: "finance",
    title: "Personal Finance",
    description: "Monitor your spending and savings.",
    tools: ["Neon", "Drizzle", "Auth.js", "Next.js", "Tailwind", "Motion"],
    visit: "https://personal-finance-moneta.vercel.app/",
    github: "https://github.com/Pilvorm/personal-finance",
  },
  {
    thumbnail: "galleria",
    title: "Galleria",
    description: "Step into the world’s most famous paintings.",
    tools: ["Next.js", "Tailwind", "Motion"],
    visit: "https://galleria-theta.vercel.app/",
    github: "https://github.com/Pilvorm/galleria",
  },
  {
    thumbnail: "spacetourism",
    title: "Space Tourism",
    description: "Go to outer space.",
    tools: ["Next.js", "Tailwind", "GSAP", "Motion"],
    visit: "https://space-tourism-sand-six.vercel.app/",
    github: "https://github.com/Pilvorm/space-tourism",
  },
  {
    thumbnail: "notes",
    title: "Notes App",
    description: "An application for capturing notes.",
    tools: ["React", "SCSS", "Bootstrap"],
    visit: "https://notes-app-git-master-pilvorms-projects.vercel.app/",
    github: "https://github.com/Pilvorm/notes-app",
  },
  {
    thumbnail: "photosnap",
    title: "Photosnap",
    description: "A platform for photographers and visual storytellers.",
    tools: ["Next.js", "Tailwind", "Motion"],
    visit: "https://photosnap-khaki.vercel.app/",
    github: "https://github.com/Pilvorm/photosnap",
  },
  {
    thumbnail: "dictionary",
    title: "Dictionary",
    description: "Online dictionary for searching word definitions, pronunciations, and meanings.",
    tools: ["Next.js", "Tailwind", "Motion"],
    visit: "https://dictionary-zeta-five.vercel.app/",
    github: "https://github.com/Pilvorm/dictionary/",
  },
  {
    thumbnail: "littlelemon",
    title: "Little Lemon",
    description: "Landing page of a restaurant allowing online reservations.",
    tools: ["React", "SCSS", "Bootstrap"],
    visit: "https://little-lemon-chg.vercel.app/",
    github: "https://github.com/Pilvorm/little-lemon",
  },
  {
    thumbnail: "logbook",
    title: "E-Logbook",
    description: "Microservices web app for intern logbook management.",
    tools: ["Next.js", "Bootstrap", "Redux", "Cypress"],
    visit: "",
    github: "https://github.com/Pilvorm",
  },
  {
    thumbnail: "caffeinline",
    title: "Caffein Line",
    description:
      "A landing page of an online cafe serving beverages and desserts.",
    tools: ["HTML", "SCSS", "Tailwind", "jQuery"],
    visit: "https://caffeinline.netlify.app/",
    github: "https://github.com/Pilvorm/Caffein-Line",
  },
  {
    thumbnail: "TributePageNew",
    title: "Cordae Tribute Page (Reimagined)",
    description:
      "A tribute page about one of my favorite hip-hop artist, Cordae.",
    tools: ["HTML", "SCSS", "jQuery"],
    visit: "https://cordae-tribute-page-reimagined.vercel.app/",
    github: "https://github.com/Pilvorm/Cordae-Tribute-Page-Reimagined",
  },
  {
    thumbnail: "Markdown",
    title: "Markdown Previewer",
    description: "A tool to preview markdowns.",
    tools: ["React", "SCSS"],
    visit: "https://markdown-previewer-tool.vercel.app/",
    github: "https://github.com/Pilvorm/markdown-previewer",
  },
  {
    thumbnail: "techfest",
    title: "TECHFEST 2022",
    description:
      "Landing page of new event held by HIMTI Binus University. Appointed as coordinator of web development division.",
    tools: ["HTML", "CSS", "Tailwind", "React"],
    visit: "https://techfest.himtibinus.or.id",
    github: "https://github.com/himtibinus",
  },
  {
    thumbnail: "hishot",
    title: "HISHOT 2022",
    description:
      "Event landing page held by HIMTI Binus University. Appointed as web development staff.",
    tools: ["HTML", "CSS", "Bootstrap", "JS"],
    visit: "https://hishot.himtibinus.or.id/",
    github: "https://github.com/himtibinus",
  },
  {
    thumbnail: "Quote",
    title: "Random Movie Quote Generator",
    description: "Get a random quote from iconic movies!",
    tools: ["HTML", "SCSS", "jQuery"],
    visit: "https://random-movie-quotes.vercel.app/",
    github: "https://github.com/Pilvorm/Random-Movie-Quote",
  },
  {
    thumbnail: "Documentation",
    title: "C Language Documentation",
    description: "A documentation of C programming language.",
    tools: ["HTML", "CSS", "JS", "Highlight.js"],
    visit: "https://c-language-documentation.vercel.app/",
    github: "https://github.com/Pilvorm/Technical-Documentation",
  },
  // {
  //   thumbnail: "SurveyForm",
  //   title: "Streaming Site Survey Form",
  //   description: "A survey form of a streaming website.",
  //   tools: ["HTML", "CSS"],
  //   visit: "https://survey-form-ecru.vercel.app/",
  //   github: "https://github.com/Pilvorm/Survey-Form",
  // },
  // {
  //   thumbnail: "lego",
  //   title: "Product Landing Page",
  //   description:
  //     "A landing page of the video game LEGO Star Wars: The Skywalker Saga.",
  //   tools: ["HTML", "CSS"],
  //   visit: "https://legoproductlanding.netlify.app/",
  //   github: "https://github.com/Pilvorm/Product-Landing",
  // },
  // {
  //   thumbnail: "TributePageOld",
  //   title: "Cordae Tribute Page (Legacy)",
  //   description: "Older version of a tribute page about Cordae.",
  //   tools: ["HTML", "SCSS"],
  //   visit: "https://cordae-tribute-page.vercel.app/",
  //   github: "https://github.com/Pilvorm/Cordae-Tribute-Page",
  // },
];
